import { useTheme as useNextTheme } from "next-themes";

import { Theme } from "@/constants/theme";

export function useTheme() {
  const { theme, setTheme } = useNextTheme();

  const isDark = theme === Theme.DARK;

  return { isDark, setTheme };
}
